<script>
import { fandomBasicMixin, fandomExtendedMixin } from 'src/modules/fandom_mixins_module.js';
import { vodafoneLabBasicMixin } from "../../modules/vodafone_lab_mixins_module.js";
import { vodafoneLabContactMixin } from "../../modules/vodafone_lab_mixins_module.js"
import { VodafoneLab } from '../../modules/vodafone_lab_module.js';
import { interactionMixin } from "src/modules/interactions_module.js";
import { get, omit } from 'lodash';

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin, vodafoneLabBasicMixin, interactionMixin, vodafoneLabContactMixin],
  data: function () {
    return {
      showBanner: false
    };
  },
  methods: {
    getTileThumbnailUrl() {
      let url = this.exists(this.content.thumbnail) ? this.getContentResponsiveImageURL("thumbnail") : this.getContentResponsiveImageURL("image");
      if (this.exists(url)) {
        url = url.replace('/original/', '/thumb/');
      }
      return url;
    },
    getContentResponsiveImage(name) {
      const content = this.content;
      if ((globalState.viewport["sm"] || globalState.viewport["xs"]) && this.exists(content[`${name}_mobile`])) {
        return this.expandUrl(content[`${name}_mobile`].url);
      } else if (this.exists(content[name])) {
        return this.expandUrl(content[name].url);
      }
      return null;
    },
    getContentResponsiveImageURL(name) {
      const imageUrl = this.getContentResponsiveImage(name);
      return this.exists(imageUrl) ? `url("${imageUrl}")` : null;
    },
    updateDownloadInteractionThis() {
      VodafoneLab.checkForInteractionAvailability(get(this.content, ["download"], {}), () => {
        this.updateDownloadInteraction(
          this.containerContent, 
          this.content.download, 
          this.content.download.interaction, 
          () => {}, 
          this.content.download.attachment.url, 
          true, 
          () => {
            if (this.checkRegistration(this.content.download)) {
              console.log(`%cData entry error\n\tdownload repeatable required`, "color: #ff0000");
            } else {
              $("#modal-registration").modal("show");
            }
          }
        );
        return false;
      });
    },
    enterHandler(el) {
      const bannerHeight = $(el).outerHeight();
      $("body").css("padding-bottom", `${bannerHeight}px`);
    },
    leaveHander(el) {
      // Warning: default body padding bottom must be 0 for the code to be correct. 
      // Otherwise it is necessary to restore the previous one.
      $("body").css("padding-bottom", `0px`);
    }
  },
  computed: {
    headerTextClass() {
      return Fandom.exists(this.content.header_text_class) ? this.content.header_text_class : "col-12 col-md-9 col-lg-6";
    },
    downloadUrl() {
      return this.checkRegistration(this.content.download) ? get(this.content, ["download","attachment", "url"], "javascript:void(0)") : 'javascript: void(0)';
    },
    contentHeaderReportMobile() {
      return {
        ...omit(this.content, ['subtitle', 'decorators', 'share']),
        title_class: "h2 text-white display-1 mb-4"
      };
    },
    hideLayer() {
      return Fandom.exists(this.content.hide_layer) ? this.content.hide_layer : false;
    },
    hasAspectRatio() {
      return Fandom.exists(this.content.height) && this.content.height.indexOf("$") === 0;
    },
    aspectRatioClasses() {
      return [
        this.hasAspectRatio ? this.content.height.replace("$", "ar-") : "w-100 h-100 ar-sm-16by9",
      ];
    },
    contentStyle() {
      const style = {};
      if (!!this.content.background_color) {
        style["background-color"] = this.content.background_color;
      }

      return style;
    },
  }
};
</script>

<template>
  <div 
    v-if="isContentVisibleToUser()" 
    v-easyadmin="easyadminId" 
    :class="contentType" 
    page-report-component
    class="position-relative"
  >
    <breadcrumb :breadcrumb="pageModel.breadcrumb"></breadcrumb>
    <intersect @leave="showBanner = true" @enter="showBanner = false">
      <div class="intersect-container">
        <div class="d-md-none d-block page-header position-relative">
          <div class="position-absolute-center layer" v-if="!hideLayer"></div>
          <div class="stripe-download" :style="contentStyle">
            <div class="position-relative overflow-hidden">
              <div class="row">
                <div class="col-12 media-column d-inline-flex px-0" :class="[hasAspectRatio ? 'align-items-end' : 'align-items-center']">
                  <div
                    class="bg-cover-center w-100 position-relative"
                    v-if="content.image"
                    :title="content.image.alt"
                    :style="{'background-image': getContentResponsiveImageURL('image')}"
                    :class="aspectRatioClasses"
                  >
                  </div>
                </div>
              </div>
              <div class="container">
                <div class="row">
                  <div class="col-12 d-flex flex-column py-4 text-column">
                    <div class="row justify-content-center">
                      <div class="col-12 px-md-5">
                        <text-section
                          :content="contentHeaderReportMobile"
                          :opt-container-content="containerContent"
                        ></text-section>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-none d-md-flex bg-cover-center align-items-md-center page-header position-relative" :style="{'background-image': getContentResponsiveImageURL('image')}">
          <div class="position-absolute-center layer" v-if="!hideLayer"></div>
          <div class="container">
            <div class="row py-md-5">
              <div :class="headerTextClass" v-if="content.title">
                <h1 class="h2 text-white display-1 mb-4 mb-md-5">{{content.title}}</h1>
                <p :class="content.description_class" class="mb-3 mb-lg-5" v-if="content.description" v-html="content.description"></p>
                <a :href="downloadUrl" @click.prevent="updateDownloadInteractionThis()" class="btn" :class="content.download.button_class || 'btn-primary'">{{content.download.title}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </intersect>
    <transition enter-active-class="animated slideInUp" leave-active-class="animated slideOutDown" @after-enter="enterHandler($event)" @after-leave="leaveHander($event)">
      <div class="download-report--fixed p-3 d-flex justify-content-center align-items-center" v-if="showBanner">
        <span class="mr-4">{{ content.download.description || content.title }}</span>
        <a :href="downloadUrl" @click.prevent="updateDownloadInteractionThis()" class="btn btn-primary px-4">{{content.download.title}}</a>
      </div>
    </transition>
    <stripe-article-interactions
      v-if="content.share"
      class="justify-content-end mb-4 mb-md-5"
      :content="content"
      :opt-container-content="containerContent"
    ></stripe-article-interactions>
    <component
      :key="stripe.$id"
      :content="stripe"
      :is="stripe.layout"
      :opt-container-content="containerContent"
      :width="7"
      v-for="(stripe) in content.stripes"
    ></component>
    <vote-interaction class="mb-md-5 pb-3" :content="content" v-if="content.vote"></vote-interaction>
    <related-collections :content="content"></related-collections>
    <stripe-contact-us :content="contactStripe" v-if="contactStripe"></stripe-contact-us>
  </div>
</template>

<style lang="scss">
[page-report-component] {

  .page-header {
    min-height: calc(100vw * .5625);

    @include media-breakpoint-up(lg) {
      min-height: 60vh;
    }

    @include media-breakpoint-down(md) {
      .mh-100vh {
        min-height: auto !important;
      }

      .ar-sm-16by9 {
        padding-bottom: 56.25%;
      }
    }
  }

  .stripe-download {
    .row {
      min-height: auto !important;
    }

    .text-column {
      [text-section-component] {
        .align-btn-group {
          margin-left: auto;
          margin-bottom: auto !important;
          padding-bottom: 0 !important;
        }
      }
    }
  }

  .layer {
    background-color: rgba(0,0,0,.25);
  }

  .author-image {
    max-height: 5rem;
    max-width: 10rem;
    height: auto;
    width: auto;
    display: inline-block;
  }

  .download-report--fixed {
    bottom: 0;
    width: 100%;
    position: fixed;
    background-color: $gray-300;
    z-index: $zindex-fixed;
  }
}
</style>
